import {
  Button,
  Container,
  FooterStyled,
  Paragraph,
  Span,
} from "../../Styles/Global.Styled";
import TwitterIcon from "../../Icons/TwitterIcon";
import FacebookIcon from "../../Icons/FacebookIcon";
import InstagramIcon from "../../Icons/InstagramIcon";
import { css } from "styled-components";
import { useNavigate } from "react-router-dom";
import { appPagesSections } from "../../helpers/data";
import useNavigateAndScroll from "../../hooks/useNavigateAndScroll";

const aboutUsCnt = css`
  flex-direction: column;
  width: 35vw;
  gap: 1vh;
`;
const widthStyle = css`
  width: auto;
`;
const companyNameStyle = css`
  color: ${({ theme }) => theme.main};
  font-size: 3.5vh;
  font-weight: 600;
`;
const gapSize = css`
  gap: 1vh;
`;
const pagesLinksCnt = css`
  justify-content: space-between;
  row-gap: 3vh;
  flex-wrap: wrap;
`;
const pageLinksCnt = css`
  flex-direction: column;
  padding: 0 3vh;
  gap: 1vh;
`;
const padding = css`
  padding: 0;
`;
const pageBttn = css`
  padding: 0 1vh;
  font-size: 2vh;
  font-weight: 600;
  align-self: flex-start;
`;
const pageSectionsCnt = css`
  flex-direction: column;
  gap: 1.5vh;
`;
const pageSectionBttn = css`
  padding: 0 1vh;
  font-weight: 200;
  align-self: flex-start;
  font-size: 1.75vh;
  gap: 1vh;
  color: ${({ theme }) => theme.thirdColor};
`;

const iconStyle = {
  width: "3vh",
  height: "3vh",
  backgroundColor: "white",
  borderRadius: "50%",
  padding: ".5vh",
};

const Footer = () => {
  const navigate = useNavigate();
  const navigateAndScroll = useNavigateAndScroll();
  return (
    <FooterStyled>
      <Container $baseStyle={aboutUsCnt} $mStyle={widthStyle}>
        <Span $baseStyle={companyNameStyle}>Fresh Flower Supply</Span>
        <Paragraph>
          At Fresh Flowers Supply, we are more than just florists; we are floral
          enthusiasts dedicated to bringing the beauty of nature to your
          doorstep.
        </Paragraph>
        {/* Icons */}
        <Container $baseStyle={gapSize}>
          <FacebookIcon style={iconStyle} />
          <TwitterIcon style={iconStyle} />
          <InstagramIcon style={iconStyle} />
        </Container>
      </Container>
      {/* Page links */}
      <Container $baseStyle={pagesLinksCnt}>
        {appPagesSections.map((page) => (
          <Container
            key={page.name}
            $baseStyle={pageLinksCnt}
            $mStyle={padding}
          >
            <Button $baseStyle={pageBttn} onClick={() => navigate(page.url)}>
              {page.name}
            </Button>
            <Container $baseStyle={pageSectionsCnt}>
              {page.sections?.map((section, index) => (
                <Button
                  key={index}
                  $baseStyle={pageSectionBttn}
                  onClick={() => {
                    page.name === "Shop"
                      ? navigate(`${page.url + "/" + section.id}`)
                      : navigateAndScroll(page.url, section.id);
                  }}
                >
                  {section.icon}
                  {section.name}
                </Button>
              ))}
            </Container>
          </Container>
        ))}
      </Container>
    </FooterStyled>
  );
};

export default Footer;
